import React, { useLayoutEffect } from 'react';
import { useReactFlow, Handle, Position } from 'reactflow';
import FlowsNode from './flowsNode';
import PlaceholderNode from './endNode';


export const YES_PLACEHOLDER_NODE_ID_PREFIX = 'yes-placeholder-';
export const NO_PLACEHOLDER_NODE_ID_PREFIX = 'no-placeholder-';

// Extension of standardNode but addds two edges
// colored and label with endNode at the end
const BranchingNode = (props) => {
  const reactFlowInstance = useReactFlow();
  
  // Use useLayoutEffect for synchronous one-time initialization
  useLayoutEffect(() => {
    if (!props.data.branchesInitialized) {
      const nodeId = props.id;
      console.log('🟢 INITIALIZING BRANCHING NODE', {
        nodeId,
        propsData: props.data
      });
      
      // Create placeholder nodes for Yes and No branches
      const yesPlaceholderId = `${YES_PLACEHOLDER_NODE_ID_PREFIX}${nodeId}`;
      const noPlaceholderId = `${NO_PLACEHOLDER_NODE_ID_PREFIX}${nodeId}`;
      
      console.log('🟢 CREATED PLACEHOLDER IDS', {
        yesPlaceholderId,
        noPlaceholderId
      });
      
      // Add placeholder nodes
      const yesPlaceholder = {
        id: yesPlaceholderId,
        type: 'endNode',
        position: { 
          x: props.xPos - 200,
          y: props.yPos + 300
        },
        data: { 
          label: 'Yes Target',
          isPlaceholder: true,
          parent: nodeId,
          children: []
        }
      };
      
      const noPlaceholder = {
        id: noPlaceholderId,
        type: 'endNode',
        position: { 
          x: props.xPos + 200,
          y: props.yPos + 300
        },
        data: { 
          label: 'No Target',
          isPlaceholder: true,
          parent: nodeId,
          children: []
        }
      };
      
      // Create edges with labels
      const yesEdge = {
        id: `edge-${nodeId}-to-${yesPlaceholderId}`,
        source: nodeId,
        target: yesPlaceholderId,
        label: 'Yes',
        type: 'smoothstep',
        style: { stroke: '#00AA00' }
      };
      
      const noEdge = {
        id: `edge-${nodeId}-to-${noPlaceholderId}`,
        source: nodeId,
        target: noPlaceholderId,
        label: 'No',
        type: 'smoothstep',
        style: { stroke: '#AA0000' }
      };
      
      console.log('🟢 CREATED EDGES', {
        yesEdge,
        noEdge
      });
      
      // Use a single atomic update
      reactFlowInstance.setNodes(nodes => {
        const currentNode = nodes.find(node => node.id === nodeId);
        if (!currentNode) return nodes; // Safety check
        
        return [
          ...nodes.filter(node => node.id !== nodeId),
          {
            ...currentNode,
            data: {
              ...currentNode.data,
              children: [yesPlaceholderId, noPlaceholderId],
              branchesInitialized: true
            }
          },
          yesPlaceholder,
          noPlaceholder
        ];
      });
      
      // Add edges in a separate operation
      reactFlowInstance.setEdges(edges => [
        ...edges, 
        yesEdge, 
        noEdge
      ]);
    }
  }, []); // Empty dependency array for one-time execution
  
  // Render the standard FlowsNode with additional handles
  return (
    <>
      <FlowsNode {...props} />
    </>
  );
};

export default BranchingNode; 